import { forwardRef, useRef } from 'react'
import GameObject from './GameObject'

const Sprite = forwardRef(({
  args,
  children,
  ...props
}, externalRef) => {

  const localRef = useRef()
  const ref = externalRef || localRef

  return (
    <GameObject
      ref={ref}
      type="Sprite"
      args={args}
      {...props}
    />
  )
})

Sprite.displayName = 'Sprite'
export default Sprite
